import React, { useState } from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { PictureAsPdf as PdfIcon } from '@mui/icons-material';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function StaffingPolicyPdfView({ token, documentMeta, title = 'Policy document' }) {
  const [feedback, setFeedback] = useState('');

  if (!documentMeta?.download_url) {
    return (
      <Typography variant="body2" color="text.secondary">
        No {title.toLowerCase()} uploaded by your employer yet.
      </Typography>
    );
  }

  const openPdf = async () => {
    setFeedback('');
    try {
      const downloadUrl = documentMeta.download_url.startsWith('http')
        ? documentMeta.download_url
        : `${API_URL}${documentMeta.download_url}`;
      const res = await fetch(downloadUrl, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error('Could not open document');
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank', 'noopener,noreferrer');
      URL.revokeObjectURL(blobUrl);
    } catch (e) {
      setFeedback(e.message);
    }
  };

  return (
    <Stack spacing={2}>
      <Alert severity="success" variant="outlined" sx={{ bgcolor: '#f0fdf4' }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ sm: 'center' }} justifyContent="space-between">
          <Box>
            <Typography variant="body2" fontWeight={600}>{title}</Typography>
            <Typography variant="caption" color="text.secondary">
              {documentMeta.original_filename}
              {documentMeta.uploaded_at && ` · ${new Date(documentMeta.uploaded_at).toLocaleDateString()}`}
            </Typography>
          </Box>
          <Button size="small" variant="contained" startIcon={<PdfIcon />} onClick={openPdf} sx={{ bgcolor: '#0d9488' }}>
            Open PDF
          </Button>
        </Stack>
      </Alert>
      {feedback && <Alert severity="warning">{feedback}</Alert>}
    </Stack>
  );
}
